const PROMPT_VARIANT_COLORS = [
  // Adjusted for better contrast on both white and black backgrounds
  "#E6194B", // #E6194B
  "#228B22", // #228B22
  "#4363D8", // #4363D8
  "#8B1EB4", // #8B1EB4
  "#FFC300", // #FFC300
  "#0099C6", // #0099C6
  "#F58231", // #F58231
  "#CA2995", // #CA2995
  "#A0C845", // #A0C845
  "#24786D", // #24786D
  "#9A6324", // #9A6324
  "#A52A2A", // #A52A2A
  "#1A237E", // #1A237E
  "#BCB800", // #BCB800
  "#CC2B34", // #CC2B34
  "#2A9D8F", // #2A9D8F
  "#D1A23D", // #D1A23D
  "#264653", // #264653
  "#F6722C", // #F6722C
  "#6A4C93", // #6A4C93
  "#007EA7", // #007EA7
  "#14B57D", // #14B57D
  "#EEB902", // #EEB902
  "#118AB2", // #118AB2
  "#EF476F", // #EF476F
  "#7209B7", // #7209B7
  "#FF6F00", // #FF6F00
  "#00A896", // #00A896
  "#E71D36", // #E71D36
  "#8E6DC1", // #8E6DC1
  "#16DB93", // #16DB93
  "#F72585", // #F72585
  "#2EC4B6", // #2EC4B6
  "#6D00B9", // #6D00B9
  "#60D394", // #60D394
  "#FFB100", // #FFB100
  "#8338EC", // #8338EC
  "#E07A5F", // #E07A5F
  "#3A86FF", // #3A86FF
  "#FF006E", // #FF006E
  "#43AA8B", // #43AA8B
  "#FF6542", // #FF6542
  "#7C3593", // #7C3593
  "#00BBF9", // #00BBF9
  "#C91A47", // #C91A47
  "#FFCF40", // #FFCF40
  "#FF595E", // #FF595E
  "#1982C4", // #1982C4
  "#51B364", // #51B364
  "#BC4749", // #BC4749
] as const;

/**
 * Picks a color from the shared palette when a prompt column is added (or
 * duplicated). The chosen value is persisted on `eval_prompts.color` and must
 * not be recomputed from display order afterward.
 */
function getPromptVariantColor(variantIndex: number): string {
  const index =
    ((variantIndex % PROMPT_VARIANT_COLORS.length) + PROMPT_VARIANT_COLORS.length) %
    PROMPT_VARIANT_COLORS.length;

  return PROMPT_VARIANT_COLORS[index];
}

export { getPromptVariantColor };
